import { BFFBadRequest } from '../interfaces/BFFBadRequest';

export default function mapControlErrors(r: BFFBadRequest): { [key: string]: { message: string } } {
  if (!r?.error?.errors) {
    return {};
  }
  const errorMap: { [key: string]: { message: string }} = {};
  r.error.errors.forEach((error) => {
    errorMap[error.field] = { message: error.message };
  });
  return errorMap;
}
